import { render, staticRenderFns } from "./InstructionalDesignCard.vue?vue&type=template&id=1127e189&scoped=true"
import script from "./InstructionalDesignCard.vue?vue&type=script&lang=js"
export * from "./InstructionalDesignCard.vue?vue&type=script&lang=js"
import style0 from "./InstructionalDesignCard.vue?vue&type=style&index=0&id=1127e189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127e189",
  null
  
)

export default component.exports